import { render, staticRenderFns } from "./SobreMiCompontcopy.vue?vue&type=template&id=78998442&"
import script from "./SobreMiCompontcopy.vue?vue&type=script&lang=js&"
export * from "./SobreMiCompontcopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports